export default {
  playGameBtn: 'ຫຼິ້ນເກມ',
  login: {
    loginTitle: 'ເຂົ້າສູ່ລະບົບ',
    phoneLabel: 'ເບີໂທລະສັບ',
    passwordLabel: 'ລະຫັດຜ່ານ',
    loginBrn: 'ເຂົ້າສູ່ລະບົບ',
    registerLink: 'ສະໝັກສະມາຊິກ'
  },
  register: {
    registerTitle: 'ສະໝັກສະມາຊິກ',
    nameLabel: 'ຊື່ໂປຣໄຟລ໌',
    usernameLabel: 'ເບີໂທລະສັບ',
    passwordLabel: 'ລະຫັດຜ່ານ',
    confirmPasswordLabel: 'ຢືນຢັນລະຫັດຜ່ານ',
    sourceLabel: 'ຊ່ອງທາງທີ່ຮູ້ຈັກ',
    sourceSelect: 'ເລືອກຊ່ອງທາງ',
    parentLabel: 'ຜູ້ແນະນຳ',
    bankData: 'ຂໍ້ມູນທະນາຄານ',
    bankLabel: 'ທະນາຄານ',
    bankSelect: 'ເລືອກທະນາຄານ',
    warningBankOne: '*** ແນະນໍາໃຫ້ໃຊ້ບັນຊີ',
    warningBankTwo: 'ກະສິກອນ ຫຼື',
    warningBankThree: 'ກຸງໄທ (ລະບົບຈະໄວທີ່ສຸດ) ***',
    bankAccountNoLabel: 'ເລກບັນຊີ',
    bankAccountNameLabel: 'ຊື່ບັນຊີ',
    registerBtn: 'ສະໝັກສະມາຊິກ',
    passwordNotEqualMsg: 'ລະຫັດຜ່ານບໍ່ກົງກັນ',
    registerSuccessMsg: 'ສະໝັກສະມາຊິກສໍາເລັດ',
    nextBtn: 'ສືບຕໍ່',
    otpLabel: 'ລະຫັດ OTP',
    confPhoneLabel: 'ຢືນຢັນເບີໂທລະສັບ',
    profileLabel: 'ຂໍ້ມູນສ່ວນຕົວ',
    currencyLabel: 'ສະກຸນເງິນ',
    languageTxt: '(ພາສາອັງກິດ)',
    requiredEngLangMsg: 'ຊື່ບັນຊີຕ້ອງເປັນພາສາອັງກິດເທົ່ານັ້ນ',
    accountFirstname: 'ຊື່ເທົ່ານັ້ນ',
    accountLastname: 'ນາມສະກຸນເທົ່ານັ້ນ'
  },
  howTo: {
    howToTitle: 'ວິທີໃຊ້',
    walletTitle: 'ຂັ້ນຕອນການໃຊ້ Wallet',
    playTitle: 'ວິທີການເຂົ້າເກມ',
    balanceTitle: 'ຂັ້ນຕອນການກວດສອບຍອດເງິນ',
    bonusTitle: 'ຂະບວນການຂໍໂບນັດ',
    bonusCancelTitle: 'ຂັ້ນຕອນການຍົກເລີກໂບນັດ'
  },
  home: {
    checkBalance: 'ກວດສອບເງິນປະຈຸບັນ',
    updateTime: 'ອັບເດດເມື່ອ',
    allBaht: '{total} ບາດ',
    allCoin: '{totalCoin} ຫຼຽນ',
    referBonusLabel: 'ໂບນັດແນະນຳໝູ່',
    receiveBtn: 'ຮັບ',
    depositTitle: 'ເຕີມເງິນ',
    refreshAllTitle: 'ກວດສອບຍອດເງິນ',
    transferTitle: 'ເອົາເງິນເຂົ້າ',
    withdrawTitle: 'ຖອນເງິນ',
    inviteTitle: 'ແນະນຳໝູ່',
    bonusTitle: 'ໂບນັດ',
    refundTitle: 'ໄດ້ເງິນຄືນ',
    slotAccountLabel: 'ບັນຊີສະລັອດຕິງ',
    viewDataTitle: 'ແຕະເພື່ອເບິ່ງຂໍ້ມູນ',
    openAccountTitle: 'ເປີດບັນຊີສໍາລັບເກມນີ້',
    sportAccountLabel: 'ບັນຊີກິລາ + ຄາສິໂນ',
    lottoAccountLabel: 'ບັນຊີຫວຍ',
    receivedInviteBonusMsg: 'ຕ້ອງການຮັບໂບນັດໝູ່ເພື່ອນບໍ່',
    confirmMsg: 'ຕ້ອງການ',
    cancelMsg: 'ບໍ່ຕ້ອງການ',
    successMsg: 'ສຳເລັດ',
    condition1Msg:
      'ຖ້າທ່ານຍອມຮັບ ຈະເຮັດໃຫ້ເງິນໃນກະເປົາເງິນ (wallet) ແລະທຸກເກມ ມີເງື່ອນໄຂ',
    condition2Msg: 'ເງື່ອນໄຂ ເຮັດໃຫ້ໄດ້ເງິນ',
    condition3Msg: 'ຂອງຈໍານວນໂບນັດທີ່ແນະນໍາໝູ່',
    condition4Msg: 'ການຍົກເລີກໂບນັດ ຖ້າເງິນຝາກລວມໂບນັດຕ່ໍາກວ່າ',
    condition5Msg: 'ສະມາຊິກຕ້ອງກົດຍົກເລີກໂບນັດກ່ອນທີ່ຈະຝາກເງິນເທື່ອຕໍ່ໄປ',
    condition6Msg: 'ຖ້າທ່ານບໍ່ກົດ ເງິນຝາກຈະຕິດຫັນ'
  },
  bonus: {
    bonusTitle: 'ໂບນັດ',
    cancelBtn: 'ຍົກເລີກ',
    promoCodePla: 'ລະຫັດໂປຣໂມຊັນ',
    searchBtn: 'ຄົ້ນຫາ',
    bonusReceived: 'ທ່ານໄດ້ຮັບໂບນັດນີ້ແລ້ວ.',
    bonusClick: 'ກົດຮັບໂບນັດ',
    currentPromotionMsg: 'ການສົ່ງເສີມປະຈຸບັນ',
    cancelBonusConMsg: 'ຍົກເລີກເງື່ອນໄຂໂບນັດ',
    confirmMsg: 'ຕ້ອງການ',
    cancelMsg: 'ບໍ່ຕ້ອງການ',
    cancelOneMsg:
      'ກະລຸນາຍ້າຍເງິນທັງໝົດໄປໃສ່ກະເປົາເງິນຫຼັກ. ກ່ອນທີ່ຈະກົດຍົກເລີກໂບນັດທຸກຄັ້ງ',
    cancelTwoMsg: '***ທຸກສະກຸນເງິນໃນເກມຈະຖືກລຶບລ້າງທັງໝົດ***',
    cancelConBonusMsg: 'ຍົກເລີກເງື່ອນໄຂໂບນັດ',
    closeMsg: 'ປິດ',
    bonusType: 'ທ່ານຕິດກັບປະເພດໂບນັດ'
  },
  profile: {
    id: 'ໝາຍເລກສະມາຊິກ',
    createdAt: 'ສະມາຊິກຕັ້ງແຕ່',
    contact: 'ຂໍ້ມູນຕິດຕໍ່',
    bankDataTitle: 'ຂໍ້ມູນທະນາຄານ',
    bankAccLabel: 'ຊື່ບັນຊີ',
    bankLabel: 'ທະນາຄານ',
    accNoLabel: 'ບັນຊີບັນຊີ'
  },
  statement: {
    statementTitle: 'ປະຫວັດທຸລະກໍາ',
    uploadStatusBtn: 'ສະຖານະອັບໂຫຼດ',
    status: 'ສະຖານະ',
    depositMsg: 'ຝາກເງິນ',
    bonusMsg: 'ຮັບໂບນັດ',
    finishBonusMsg: 'ໂບນັດສິ້ນສຸດ',
    withdrawMsg: 'ຖອນເງິນຈາກ',
    transferMsg: 'ໂອນເງິນ',
    inProgressMsg: 'ກໍາລັງເຮັດ',
    successMsg: 'ສຳເລັດ',
    failMsg: 'ບໍ່ສຳເລັດ'
  },
  spin: {
    error: {
      NO_CLAIMABLE_COUPON: 'ບໍ່ສາມາດຮັບຄູປອງໄດ້',
      INVALID_PRIZE_CODE: 'ບໍ່ພົບຄູປອງ',
      INVALID_CODE: 'ລະຫັດຄູປອງບໍ່ຖືກຕ້ອງ',
      INVALID_COUPON_TYPE: 'ປະເພດຄູປອງບໍ່ຖືກຕ້ອງ',
      COUPON_EXPIRED: 'ຄູປອງໝົດອາຍຸ',
      BONUS_REMAINING: 'ໂບນັດທີ່ຍັງຄ້າງຢູ່'
    }
  },
  modals: {
    confirmBtn: 'ຕົກລົງ',
    cancelBtn: 'ຍົກເລີກ',
    saveBtn: 'ບັນທຶກ',
    successMsg: 'ສຳເລັດ',
    savedMsg: 'ບັນທຶກຂໍ້ມູນສຳເລັດ',
    errorMsg: 'ເກີດຄວາມຜິດພາດຂຶ້ນ',
    amountLabel: 'ຈໍານວນ (ບາດ)',
    receiveAtLabel: 'ມື້ໄດ້ຮັບ',
    transferMsg: 'ການໂອນເງິນສົບຜົນສໍາເລັດ',
    agreement: {
      title: 'ເງື່ອນໄຂການນໍາໃຊ້'
    },
    bonus: {
      title: 'ໂບນັດ',
      receiveBtn: 'ຮັບໂບນັດ'
    },
    changePassword: {
      title: 'ປ່ຽນລະຫັດຜ່ານ',
      oldPasswordLabel: 'ລະຫັດຜ່ານເກົ່າ',
      newPasswordLabel: 'ລະຫັດຜ່ານໃຫມ່',
      newConfirmPasswordLabel: 'ຢືນຢັນລະຫັດຜ່ານໃຫມ່',
      passwordNotEqualMsg: 'ລະຫັດຜ່ານໃຫມ່ບໍ່ກົງກັນ'
    },
    condition: {
      title: 'ເງື່ອນໄຂ'
    },
    deposit: {
      title: 'ບັນຊີສໍາລັບການໂອນເຕີມເງິນ',
      noteOneTxt: 'ຕື່ມເງິນໃສ່ບັນຊີ ຕ້ອງເປັນບັນຊີລຸ່ມນີ້ເທົ່ານັ້ນ',
      noteTwoTxt: '(ເງິນຈະຖືກໂອນເຂົ້າ Wallet ພາຍໃນ 1 ນາທີ)',
      bank: 'ທະນາຄານ',
      uploadSlipOneTxt: 'ເວລາອັບໂຫຼດຈະຖືກປິດການນຳໃຊ້',
      uploadSlipTwoTxt: 'ທຸກໆມື້',
      selectImageTxt: 'ກະລຸນາເລືອກໄຟລ໌ຮູບພາບ',
      selectImageBtn: 'ເລືອກຮູບ',
      uploadBtn: 'ອັບໂຫຼດ',
      conditionSlip1Txt:
        '** ຕ້ອງເປັນໃບຮັບເງິນຂອງທະນາຄານທີ່ແທ້ຈິງເທົ່ານັ້ນ ຢ່າໃຊ້ໃບຮັບເງິນຂອງທະນາຄານທຶກຫນ້າຈໍດ້ວຍຕົວເອງ',
      conditionSlip2Txt:
        '** ຫຼັງຈາກໂອນເງິນແລ້ວ ຮູບພາບຈະຕ້ອງຖືກອັບໂຫຼດໃບຮັບເງິນຂອງທະນາຄານພາຍໃນ 1 ຊົ່ວໂມງເທົ່ານັ້ນ',
      qr1Txt: 'ສະແກນລະຫັດ QR  Code ນີ້ ເພື່ອໂອນເງິນ',
      qr2Txt: 'ກະລຸນາໂອນພາຍໃນເວລາ',
      qr3Txt: 'ນາທີ',
      qr4Txt:
        '** ຖ້າໂອນຫຼັງຈາກເວລານັ້ນ ບໍລິສັດສະຫງວນສິດທີ່ຈະບໍ່ຮັບຜິດຊອບໃນທຸກກໍລະນີ',
      cancelBtn: 'ຍົກເລີກ',
      transferBtn: 'ໂອນເງິນສຳເລັດ',
      qrAmountTxt: 'ໃສ່ຈໍານວນແລະກົດສ້າງລະຫັດ QR Code',
      qrCondition1Txt:
        '1. ການຝາກເງິນເຂົ້າບັນຊີ ລູກຄ້າຕ້ອງສ້າງລະຫັດ QR Code  ໃໝ່ສຳລັບທຸກໆການໂອນເງິນ',
      qrCondition2Txt:
        '2. ຊື່ບັນຊີ ແລະເລກບັນຊີທີ່ໃຊ້ໃນການຝາກຕ້ອງກົງກັບອັນທີ່ທ່ານລົງທະບຽນນຳ',
      qrCondition3Txt:
        '3. ຖ້າເຈົ້າບໍ່ໃຊ້ບັນຊີທີ່ເຈົ້າສະໝັກເພື່ອໂອນເຂົ້າ ຖ້າມີຂໍ້ຜິດພາດເກີດຂຶ້ນ, ພວກເຮົາຈະບໍ່ຮັບຜິດຊອບຕໍ່ການໂອນເງິນທີ່ຜິດພາດ.',
      qrConditionWw1Txt:
        'QR Code ສາມາດຝາກໄດ້ 1 ຄັ້ງເທົ່ານັ້ນ. ແລະໂອນພາຍໃນເວລາທີ່ກໍານົດໄວ້ເທົ່ານັ້ນ',
      qrConditionWw2Txt:
        'ຢ່າເຮັດການໂອນເງິນຊ້ຳໆ ຢ່າປ່ຽນຕົວເລກ. (ຖ້າທ່ານບໍ່ປະຕິບັດຕາມ, ເງິນຈະບໍ່ຖືກເຂົ້າໄປໃນບັນຊີຂອງທ່ານ. ລະບົບຈະບໍ່ເຕີມເງິນ/ຄືນເງິນໃຫ້ລູກຄ້າໃນທຸກກໍລະນີ)',
      qrConditionWw3Txt: 'ເງິນຝາກຂັ້ນຕ່ຳ {minDeposit} ບາດ',
      amountPla: 'ຈໍານວນ',
      qeCreateBtn: 'ສ້າງລະຫັດ QR Code',
      linkTruePla: 'ວາງລິ້ງທີ່ສຳເນົາໄວ້',
      linkSendBtn: 'ສົ່ງລິ້ງ',
      refreshAmountMsg: 'ກະລຸນາກົດໂຫຼດຍອດຄົງເຫຼືອປັດຈຸບັນ',
      uploadSuccessMsg: 'ອັບໂຫຼດໃບສະໝຸດສຳເລັດ',
      linkSendMsg: 'ສົ່ງລິ້ງສຳເລັດ',
      conditionTrueWalletAuto:
        '***ທ່ານຕ້ອງໃຊ້ເບີໂທລະສັບທີ່ລົງທະບຽນ ({username}) ເພື່ອໂອນເງິນເທົ່ານັ້ນ.<br/><br/>***ຖ້າໝາຍເລກ wallet ບໍ່ໃສ່ໝວກກັນກະທົບທີ່ລົງທະບຽນແລ້ວ ໃຫ້ແຈ້ງ admin ເພື່ອປ່ຽນເບີໂທລະສັບກ່ອນການຝາກເງິນ. ຖ້າທ່ານບໍ່ປະຕິບັດຕາມ, ພວກເຮົາຈະບໍ່ຮັບຜິດຊອບໃນທາງໃດກໍ່ຕາມ. ທັງໝົດ<br/><br/>***ຈຳນວນຂັ້ນຕ່ຳ 2 ບາດ'
    },
    editProfile: {
      title: 'ແກ້ໄຂຂໍ້ມູນສ່ວນຕົວ',
      bankAccName: 'ຊື່ບັນຊີ',
      bankLabel: 'ທະນາຄານ',
      bankAccNoLabel: 'ເລກບັນຊີ'
    },
    invite: {
      title: 'ແນະນຳໝູ່',
      linkSendTxt: 'ສົ່ງລິ້ງນີ້ໄປຫາໝູ່',
      copyTxt: 'ສຳເນົາ',
      inviteTurnoverBtn: 'ເກັບກໍາຂໍ້ອ້າງຂອງຫມູ່ເພື່ອນ',
      fromLabel: 'ໄດ້ຮັບຈາກ',
      amountLabel: 'ຈໍານວນ (ບາດ)',
      createdAtLabel: 'ມື້ໄດ້ຮັບ'
    },
    promotion: {
      title: 'ໂປຣໂມຊັນ',
      promo1Txt: '*** ການຍົກເລີກໂບນັດ ຖ້າເງິນຝາກບວກໂບນັດແມ່ນຕ່ໍາກວ່າ',
      promo2Txt: 'ສະມາຊິກຕ້ອງກົດຍົກເລີກໂບນັດກ່ອນທີ່ຈະຝາກເງິນຄັ້ງຕໍ່ໄປ',
      promo3Txt: 'ຖ້າທ່ານບໍ່ກົດ ເງິນຝາກຈະຕິດຫັນ',
      receivePromoBtn: 'ກົດຮັບໂປຣໂມຊັນ',
      searchingMsg: 'ກຳລັງຊອກຫາ',
      promoNotFoundMsg: 'ບໍ່ພົບໂປຣໂມຊັນນີ້'
    },
    refund: {
      title: 'ໄດ້ເງິນຄືນ',
      refundAmountLabel: 'ยอดสะสมคืนยอดเสีย',
      receiveBtn: 'รับ',
      receiveRefundBtn: 'ໄດ້ເງິນຄືນ',
      refundCon1Txt: 'ບໍ່ສາມາດຮັບເງິນຄືນຂອງຍອດເງິນທີ່ເສຍໄປໄດ້',
      refundCon2Txt: 'ເພາະວ່າເຈົ້າຕິດໂບນັດ',
      refundNotFondTxt: 'ບໍ່ພົບຂໍ້ມູນການຄືນເງິນ',
      refundToWallet1Msg: 'ต้องการรับยอดคืนยอดเสีย',
      refundToWallet2Msg:
        'หากท่านกดรับ จะทำให้เงินใน wallet และ เกมทั้งหมด ติดเงื่อนไขด้วย',
      refundToWallet3Msg: 'เงื่อนไข ต้องทำให้ได้เงิน',
      refundToWallet4Msg: 'ของยอดคืนยอดเสีย',
      refundToWallet5Msg: 'การยกเลิกโบนัส หากยอดเงินฝากรวมโบนัสต่ำกว่า',
      refundToWallet6Msg: 'สมาชิกต้องกดยกเลิกโบนัสก่อนทำรายการฝากครั้งต่อไป',
      refundToWallet7Msg: 'ไม่กดเงินฝากจะติดเทิร์น'
    },
    slip: {
      title: 'ລາຍການອັບໂຫຼດ',
      currentStatusTxt: 'ກວດສອບສະຖານະພາບໃນປະຈຸບັນ',
      statusLabel: 'ສະຖານະ',
      imgLabel: 'ຮູບ',
      selectView: 'ເອີ້ນເບິ່ງ',
      inProgressMsg: 'ກໍາລັງເຮັດ',
      successMsg: 'ສຳເລັດ',
      failMsg: 'ບໍ່ສຳເລັດ',
      incorrectSlipMsg: 'ຄວາມຜິດພາດພຽງ',
      destAccInvalidMsg: 'ໝາຍເລກບັນຊີປາຍທາງບໍ່ຖືກຕ້ອງ',
      duplicateSlipMsg: 'ໃບຮັບເງິນຂອງທະນາຄານຊ້ຳ',
      unstableRefNoMsg: 'ເອກະສານອ້າງອີງບໍ່ສາມາດອ່ານໄດ້',
      wrongCaptchaMsg: 'captcha ຜິດສາມເທື່ອຕິດຕໍ່ກັນ',
      invalidSlipMsg: 'ໃບຮັບເງິນຂອງທະນາຄານບໍ່ສາມາດອ່ານໄດ້',
      notMatchMsg: 'ໝາຍເລກບັນຊີຂອງຜູ້ນບໍ່ກົງກັບແອັບພລິເຄຊັນ',
      expiredSlipMsg: 'ເໃບຮັບເງິນຂອງທະນາຄານໝົດອາຍຸແລ້ວ',
      unknownErrorMsg: 'ພົບຂໍ້ຜິດພາດ  ກະລຸນາຕິດຕໍ່ຜູ້ເບິ່ງແຍງລະບົບ.'
    },
    slotAccount: {
      resetPasswordTxt: 'ຣີເຊັດລະຫັດຜ່ານ',
      canNotPlayTxt: 'ເມື່ອບໍ່ສາມາດຫຼິ້ນເກມໄດ້',
      transferToGameLabel: 'ເອົາເງິນເຂົ້າໄປໃນເກມ (ບາດ)',
      haveAmountTxt: 'ມີເງິນໃນເກມ',
      playGameBtn: 'ຫຼິ້ນເກມ',
      androidAppBtn: 'ແອັບໃນ Android',
      iosAppBtn: 'ແອັບໃນ iOS',
      activeBtn: 'ເປີດໃຊ້ການ'
    },
    transfer: {
      title: 'ໂອນເງິນ',
      selectAccTxt: 'ເລືອກບັນຊີ',
      transferFromTxt: 'ໂອນຈາກ',
      walletTxt: 'Wallet (ບາດ)',
      transferToTxt: 'ກັບ',
      bahtTxt: 'ບາດ',
      minAmountLabel: 'ຕໍ່າສຸດ',
      amountPla: 'ຈໍານວນ',
      transferBtn: 'ໂອນເງິນ',
      selectAccMsg: 'ກະລຸນາເລືອກບັນຊີທີ່ຖືກຕ້ອງ',
      canNotTransferMsg: 'ບໍ່ສາມາດເລືອກໂອນ/ຮັບບັນຊີດຽວກັນໄດ້',
      minAmountMsg: 'ຈໍານວນຕໍາ່ສຸດ ແມ່ນ'
    },
    withdraw: {
      title: 'ຖອນເງິນ',
      amountWithdrawTxt: 'ຈໍານວນການຖອນເງິນ (ບາດ)',
      maxTxt: 'ສູງສຸດ',
      bonusConTxt:
        'ກາລຸນາແຈ້ງຖອນຍອດເງິນທັງຫມົດເທົ່ານັ້ນ ຫາກຮັບໂປຮແລ້ວແຈ້ງຖອນບໍ່ຫມົດ ເຄດິດທີ່ເຫລືອໄວ້ຈະຖືກຕັດອອກທັງຫມົດ',
      confBrn: 'ຢືນຢັນ',
      maxAmountMsg: 'ຈໍານວນສູງສຸດ ແມ່ນ',
      waiteTransfer: 'ກະລຸນາລໍຖ້າໃຫ້ເງິນເຂົ້າບັນຊີຂອງເຈົ້າກ່ອນ'
    },
    editBankAccName: {
      title: 'ຊື່ -ສະກຸນບັນຊີທະນາຄານ',
      warningTxt:
        'ກະລຸນາແກ້ໄຂ ຊື່ -ສະກຸນບັນຊີທະນາຄານ ເປັນ ພາສາອັງກິດ ເທົ່ານັ້ນ',
      accNamePla: 'ຊື່ -ນາມສະກຸນบບັນຊີ (ພາສາອັງກິດ)',
      editBtn: 'ແກ້ໄຂ',
      requiredEngLangMsg: 'ຊື່ບັນຊີຕ້ອງເປັນພາສາອັງກິດເທົ່ານັ້ນ'
    }
  },
  bottomMenu: {
    home: 'ໜ້າຫຼັກ',
    register: 'ສະໝັກສະມາຊິກ',
    howTo: 'ວິທີໃຊ້',
    contact: 'ຕິດຕໍ່ເຮົາ'
  },
  bottomMenuAuth: {
    profile: 'ຂໍ້ມູນສ່ວນຕົວ',
    condition: 'ເງື່ອນໄຂ',
    statement: 'ປະຫວັດທຸລະກໍາ',
    contact: 'ຕິດຕໍ່ເຮົາ'
  },
  errorMsg: {
    UNAUTHORIZED: 'ປະຕິເສດການເຂົ້າເຖິງ ເນື່ອງຈາກບໍ່ໄດ້ເຂົ້າສູ່ລະບົບ',
    EXPIRED_AUTH_TOKEN: 'ການເຂົ້າເຖິງຖືກປະຕິເສດ ເນື່ອງຈາກ token ໝົດອາຍຸ',
    INVALID_USER_1: 'ບໍ່ສາມາດຢືນຢັນຕົວຕົນໄດ້',
    INVALID_USER_2: 'ບໍ່ສາມາດຢືນຢັນຕົວຕົນໄດ້',
    INVALID_USER_3: 'ບໍ່ສາມາດຢືນຢັນຕົວຕົນໄດ້',
    INVALID_USER_4: 'ບໍ່ສາມາດຢືນຢັນຕົວຕົນໄດ້',
    INVALID_IP: 'ບໍ່ສາມາດເຂົ້າເຖິງໄດ້ ເນື່ອງຈາກ IP address',
    NOT_AREASLOT: 'ບໍ່ພົບຜູ້ໃຊ້ນີ້ຢູ່ໃນ AREASLOT',
    NOT_UFABET: 'ບໍ່ພົບຜູ້ໃຊ້ນີ້ຢູ່ໃນ UFABET',
    OTP_BLOCK: 'ທ່ານໄດ້ເຮັດທຸລະກໍາຫຼາຍເກີນໄປ. ກະລຸນາລໍຖ້າຈັກໜ່ອຍ',
    OTP_TOKEN_INVALID: 'OTP ບໍ່ສາມາດກວດສອບໄດ້',
    OTP_NOT_EXIST: 'OTP ບໍ່ສາມາດກວດສອບໄດ້',
    OTP_VERIFIED: 'OTP ໄດ້ຮັບການກວດສອບແລ້ວ',
    OTP_EXPIRED: 'ລະຫັດ OTP ໝົດອາຍຸແລ້ວ',
    OTP_CODE_INVALID: 'ລະຫັດ OTP ບໍ່ຖືກຕ້ອງ',
    OTP_CODE_VALID: 'ກວດສອບ OTP ຖືກຕ້ອງ',
    EXISTING_USER: 'ເບີໂທນີ້ໄດ້ຖືກລົງທະບຽນແລ້ວ',
    EXISTING_BANK: 'ບັນຊີທະນາຄານນີ້ຖືກໃຊ້ແລ້ວ',
    INVALID_USER_INFO: 'ຂໍ້ມູນຜູ້ໃຊ້ບໍ່ຖືກຕ້ອງ',
    UNVERIFIED_OTP: 'ກະລຸນາຢືນຢັນເບີໂທລະສັບ',
    GAME_ACTIVATION_FAIL: 'ບໍ່ສາມາດເປີດໃຊ້ໄດ້',
    INVALID_BANK: 'ຂໍ້ມູນທະນາຄານບໍ່ຖືກຕ້ອງ',
    BANK_ACCOUNT_NAME_ENG: 'ຊື່ບັນຊີຕ້ອງເປັນພາສາອັງກິດເທົ່ານັ້ນ',
    REGISTER_FAIL: 'ການລົງທະບຽນລົ້ມເຫລວ',
    NO_USER: 'ບໍ່ພົບຂໍ້ມູນຜູ້ໃຊ້ນີ້',
    WRONG_PASSWORD: 'ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    REQUEST_LIMIT: 'ທ່ານໄດ້ເຮັດທຸລະກໍາຫຼາຍເກີນໄປ ກະລຸນາລໍຖ້າຈັກໜ່ອຍ',
    WRONG_CREDENTIAL: 'ເບີໂທລະສັບ/ລະຫັດຜ່ານ ບໍ່ຖືກຕ້ອງ',
    INACTIVE_USER: 'ຜູ້ໃຊ້ນີ້ຖືກປິດໃຊ້ງານ',
    LOGIN_FAIL: 'ບໍ່ສາມາດໃຊ້ໄດ້ໃນຂະນະນີ້',
    BONUS_REMAINING: 'ໂບນັດທີ່ຍັງຄ້າງຢູ່',
    BONUS_ALREADY_ACTIVE: 'ໂບນັດນີ້ມີການເຄື່ອນໄຫວຢູ່ແລ້ວ',
    BONUS_MAX_CLAIMED: 'ບໍ່ສາມາດຮັບໂບນັດນີ້ໄດ້',
    BONUS_CONDITION: 'ທ່ານບໍ່ສາມາດຍົກເລີກໂບນັດໄດ້ ຍ້ອນເງື່ອນໄຂ',
    BONUS_CLEAR: 'ໂບນັດຖືກຍົກເລີກແລ້ວ',
    INVITE_COLLECT: 'ລະບົບຈະລວບລວມພວກມັນໂດຍອັດຕະໂນມັດ',
    INTERNAL_SERVER_ERROR: 'ລະບົບຂັດຂ້ອງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ',
    INVITE_INACTIVE: 'ປິດໂບນັດແນະນຳໝູ່',
    NO_INVITE_BONUS: 'ບໍ່ພົບໂບນັດແນະນຳໝູ່',
    NO_INVITEE_PLAY_INFO: 'ບໍ່ສາມາດຊອກຫາຂໍ້ມູນໝູ່ທີ່ທ່ານແນະນຳໄດ້',
    INVITE_BONUS_SUCCESS: 'ທ່ານໄດ້ຮັບໂບນັດຂອງທ່ານສຳເລັດແລ້ວ',
    INVITE_BONUS_FAIL: 'ທ່ານບໍ່ໄດ້ຮັບໂບນັດ',
    OK: 'ok',
    KEY_MISSING: 'ບໍ່ພົບ ລະຫັດ',
    KEY_INVALID: 'ລະຫັດ ບໍ່ຖືກຕ້ອງ',
    SUCCESS: 'ສໍາເລັດ',
    OTP_SEND_FAIL: 'ບໍ່ສາມາດສົ່ງ OTP ໄດ້',
    OTP_VERIFY_FAIL: 'ບໍ່ສາມາດກວດສອບ OTP ໄດ້',
    NO_DATA: 'ບໍ່ພົບຂໍ້ມູນ',
    NO_PROMOTION: 'ບໍ່ພົບໂປຣໂມຊັນນີ້',
    PROMOTION_RECEIVED: 'ທ່ານໄດ້ຮັບໂປຣໂມຊັນນີ້ແລ້ວ',
    BONUS_FULL: 'ໂປຣໂມຊັນເຕັມແລ້ວ',
    QR_FAIL: 'ບໍ່ສາມາດສ້າງ QR  Code ໄດ້ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.',
    NO_REFUND: 'ບໍ່ພົບການຄືນເງິນ',
    REFUND_CONDITION: 'ທ່ານບໍ່ໄດ້ຢູ່ໃນເງື່ອນໄຂຂອງການໄດ້ຮັບເງິນຄືນ',
    REFUND_SUCCESS: 'ທ່ານໄດ້ຮັບເງິນຄືນສຳເລັດແລ້ວ',
    REFUND_INACTIVE: 'ລະບົບການຈ່າຍເງິນຄືນໄດ້ຖືກປິດ',
    REFUND_MINIMUM: 'ຈຳນວນສະສົມຈະຕ້ອງຫຼາຍກວ່າ 0 ບາດ',
    NO_BANK: 'ບໍ່ພົບຂໍ້ມູນບັນຊີທະນາຄານຂອງຜູ້ໃຊ້ນີ້',
    NO_WALLET: 'ບໍ່ພົບຂໍ້ມູນ Wallet (ກະເປົາເງິນ) ຂອງຜູ້ໃຊ້ນີ້',
    SLOT_ALREADY_ACTIVE: 'ເກມນີ້ໄດ້ຖືກເປີດໃຊ້ແລ້ວ.',
    SLOT_ACTIVATE_FAIL: 'ບໍ່ສາມາດເປີດໃຊ້ໄດ້',
    SLOT_NO_ACCOUNT: 'ບໍ່ພົບບັນຊີຜູ້ໃຊ້ສຳລັບເກມນີ້.',
    SLOT_RESET_PASSWORD_FAIL: 'ບໍ່ສາມາດປ່ຽນລະຫັດຜ່ານໄດ້',
    TRANSFER_MINIMUM: 'ຈຳນວນຈະຕ້ອງຫຼາຍກວ່າ 0',
    NO_GAME: 'ບໍ່ພົບຂໍ້ມູນເກມ',
    MONEY_NOT_ENOUGH: 'ຈໍານວນບໍ່ພຽງພໍ',
    TRANSFER_FAIL:
      'ການໂອນລົ້ມເຫລວ ເງິນໄດ້ຖືກໂອນກັບຄືນໄປ Wallet (ກະເປົາເງິນ)  ສໍາເລັດແລ້ວ',
    SLIP_UPLOAD_FAIL: 'ບໍ່ສາມາດເຮັດທຸລະກໍາໄດ້',
    REQUEST_LIMIT_1MIN: 'ທ່ານໄດ້ເຮັດທຸລະກໍາຫຼາຍເກີນໄປ ກະລຸນາລໍຖ້າປະມານ 1 ນາທີ',
    SLIP_NO_FILE: 'ບໍ່ໄດ້ອັບໂຫລດໄຟລ໌',
    SLIP_INVALID_FILE: 'ໄຟລ໌ຮູບພາບບໍ່ຖືກຕ້ອງ',
    TRUELINK_DUPLICATE: 'ລິ້ງຊ້ຳ',
    TRUELINK_INVALID: 'ລິ້ງບໍ່ຖືກຕ້ອງ ຫຼືຖືກໃຊ້ແລ້ວ',
    PHONE_NUMBER_REQUIRE_10_DIGIT: 'ເບີໂທລະສັບຕ້ອງຮອງຮັບ 10 ຕົວເລກ'
  }
}
